export const TOAST_SEVERITY = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

export const TOAST_DEFAULT_DURATION: Record<string, number> = {
  success: 4000,
  warning: 6000,
  error: 0,
};
